<template>
  <div class="page-content questionnaire" style="min-height: 90vh;" v-loading="loading">
    <div class="startTitle">微问卷</div>
    <el-row>
      <el-col :span="6" style="width:23%;" class="questionnairebox"  v-for="(item,index ) in znjcList" :key="index">
        <div class="itemBox" @click="toPage()">
            <div class="questionnaireD">
              <img class="questionnaireDimg" :src="item.img">
              <div class="questionnaireDd">
                <div class="questionnaireDd1">问卷名称</div>
                <div class="questionnaireDd2">{{item.typeName}}风险评估与筛查</div>
              </div>
            </div>
            <div class="questionnaireD1">
              <div class="questionnaireD1d1">评估结果</div>
              <div class="questionnaireD1d2" :style="{color:item.color == null?'#000000':item.color}">{{item.result}}</div>
            </div>
            <div class="questionnaireD2">
              <div class="questionnaireD2d1">评估时间</div>
              <div class="questionnaireD2d2">{{item.addTime}}</div>
            </div>
        </div>
        <div class="questionnaireboxborder5_17"></div>
      </el-col>
    </el-row>
<!--  -->
          <el-dialog :visible.sync="open" width="1000px" :show-close="false" style="line-height:1px; text-align:center; margin-top:0; padding-top:0;">

            <img class='codewrapImg' src='@/assets/images/app_coder2.png'/>
            <div class='codewrapdiv' >为了您更快捷全面的获取健康数据及更便捷的查看健康数据报告</div>
            <div class='codewrapdiv' >请您使用吾征AI健康APP或微信公众号体验健康服务</div>
            <div class='codewrapdiv2'>（扫描下方二维码下载安装APP或关注吾征AI微信公众号）</div>
            <div style='margin-bottom: 30px;'>
                <div class="codewrap" >
                  <img src="@/assets/images/app_coder.png">
                  <p>吾征AI健康APP</p>
                  <p>扫码下载</p>
                </div>
                <div class="codewrap">
                  <img src="@/assets/images/weixin_coder.png">
                  <p>吾征AI公众号</p>
                  <p>扫码关注</p>
                </div>
            </div>
        <!-- 关注公众号 -->
        <div id="alertwarp">
          <div id="alertmask"></div>
          <div id="alertwx">
          </div>
        </div>
      </el-dialog>
  </div>
</template>

<script>
import '@/assets/css/backcommon.css'
import Cookies from 'js-cookie'
import baseAPI from "@/api/baseAPI";
import { userDataReport ,microQuestionnaire} from "@/api/dataReport"
import { Message } from 'element-ui'
export default {
  name: "questionnaire",
  data () {
    return {
       loading: true,
      open: false,
      userId: "",
      defaultHeight: {
        height: ""
      },
      znjcList: []
    }
  },
  components: {},
  beforeMount () {
    this.userId = this.$store.state.user.userId;
    if (this.userId === "") {
      console.log(Cookies.get("userInfo"));
      this.userId = JSON.parse(Cookies.get("userInfo"))["userId"];
    }
  },
  mounted () {
    //页面创建时执行一次getHeight进行赋值，顺道绑定resize事件
    window.addEventListener("resize", this.getHeight);
    this.getHeight();
    this.userDataReport();
  },
  methods: {
    // 循环value进行值和单位分割
    splitNumAndString (val) {
      var re = /^[0-9]+.?[0-9]*$/; //判断字符串是否为数字 //判断正整数 /^[1-9]+[0-9]*]*$/
      for (var i = val.length - 1; i > 0; i--) {
        if (re.test(val.charAt(i))) {
          var value = val.substring(0, i + 1);
          var unit = val.substring(i + 1, val.length);
          var param = { "value": value, "unit": unit };
          return param;
        }
      };
    },
    //定义方法，获取高度减去头尾
    getHeight () {
      this.defaultHeight.height = window.innerHeight - 105 + "px";
    },
    //初始
    userDataReport () {
      this.loading = true;
      microQuestionnaire({'userId':this.userId,'type':12}).then(res => {
        var data = res.data;
        if (data.code === 200) {
          this.znjcList = data.data;
        }
        this.loading = false;
      })
    },
    // 判断用户是否进行过改项测量，没有的话进行提示
    toPage (img, name, id, value,unit ) {
      this.open = true;
     /* if (value == null) {
        Message({
          message: '您还没有进行测量！',
          type: 'warning',
          duration: 5 * 1000
        })
        return;
      }
      this.$router.push({
        path: '/personCenter/questionnaire/znjcTable',
        query: {
          img,
          name,
          id,
          unit
        }
      })*/

    }
  },
}
</script>

<style >
.el-dialog__body{
padding-top: 0;
}
.codewrapImg{
width: 128px;
height: 128px;
margin-bottom: 50px;
}
.codewrapdiv{
height: 15px;
color:#000000;
font-size: 18px;
font-weight: bold;
margin-bottom: 15px;
}
.codewrapdiv2{
height: 15px;
color:#666;
font-size: 15px;
font-weight: 400;
margin-bottom: 55px;
}
.memberCenter .el-dialog
__header{
  border:none;
}
.codewrap {
  display: inline-block;
  width: 100px;
  margin-right:70px;
  margin-left:70px;
  text-align: center;
}
.codewrap img {
  padding-bottom: 10px;
  /* margin-top: 40px; */
}
.codewrap p {
  width: 100%;
  height: 22px;
  line-height: 22px;
   /* margin-bottom: 20px; */
}
.questionnaire .questionnairebox {
  /*border: 1px solid red;*/
  min-height: 130px;
  cursor: pointer;
  border-radius: 8px;
  margin-left: 18px;
  margin-top: 20px;
  padding: 2%;
  background: #fff;
  border: 1px solid #f1f1f1;
  -webkit-transition: all 0.5s ease;
  transition: all 0.5s ease;
  position: relative;
}
.questionnaire .questionnaireboxborder5_17{
  width: 100%;
  height: 8px;
  position: absolute;
  left: 0;
  bottom: -7px;
  z-index: 999;
  background-color: #fafafa;
  border-bottom: 1px solid #f1f1f1;
  border-radius: 0 0 50px 50px;

}
.questionnaire .questionnairebox:hover {
  -webkit-box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}
.questionnaire .questionnairebox .itemBox {
  position: relative;
}
.questionnaire .questionnairebox .itemBox h4 {
  margin: 0;
  font-size: 16px;
  font-weight: 500;
  color: rgba(101, 101, 101, 1);
  padding-bottom: 10px;
}
.questionnaire .questionnairebox .itemBox .numberUnit h2 {
/*  margin: 0;
  font-size: 20px;
  font-weight: 800;
  color: rgba(51, 51, 51, 1);
  display: inline-block;
  padding-bottom: 10px;*/

      margin: 0;
    font-size: 20px;
    line-height: 40px;
    font-weight: 800;
    color: rgba(51, 51, 51, 1);
    display: inline-block;
    padding-bottom: 10px;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
    width: 71%;
}
.questionnaire .questionnairebox .itemBox .pad20 {
  padding: 18px;
}
.questionnaire .questionnairebox .itemBox .numberUnit span {
  margin-left: 10px;
  display: inline-block;
  font-size: 16px;
  font-weight: 500;
  color: rgba(153, 153, 153, 1);
}
.questionnaire .questionnairebox .itemBox span.time {
  font-size: 13px;
  font-weight: 400;
  color: rgba(153, 153, 153, 1);
}


.questionnaireD{
  overflow: hidden;
  padding-bottom: 20px;
  margin-bottom: 20px;
  border-bottom: 1px solid #E6E6E6;
}
.questionnaireDimg{
  float: left;
  width: 48px;
  height: 48px;
  margin-right: 5%;
}
.questionnaireDd{
  float: left;
  width: 70%;

  /* margin-top: 10px; */
}
.questionnaireDd1{
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: 400;
  color: #999999;
  margin-bottom: 5px;
}
.questionnaireDd2{
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 18px;
  font-family: PingFang SC;
  font-weight: bold;
  color: #000000;
}
.questionnaireD1{
  overflow: hidden;
  margin-bottom: 14px;
}
.questionnaireD1d1{
  float: left;
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: 400;
  color: #999999;
  margin-top: 6px;
}
.questionnaireD1d2{
  float: right;
  font-size: 22px;
  font-family: PingFang SC;
  font-weight: 400;
  color: #000000;
}
.questionnaireD2{
  overflow: hidden;
}
.questionnaireD2d1{
  float: left;
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: 400;
  color: #999999;
}
.questionnaireD2d2{
  float: right;
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: 400;
  color: #000000;
}
</style>



// WEBPACK FOOTER //
// src/views/personCenter/questionnaire.vue